(function ($) {
  //Time and Temperature Block
  Drupal.behaviors.timeAndTemperatureBlock = {
		    attach: function (context) {
		    		Drupal.behaviors.timeAndTemperatureBlockCreator(context);
		    }
  }

  Drupal.behaviors.timeAndTemperatureBlockCreator = function (context){
	$(".timeSection", context).each(function (index){
	var isWhiteBackground = $(this).data( "is-white-background" );
	var text = $(this).data( "text" );
	var initialTime = $(this).data( "time" );
	var initialTemp = $(this).data( "temp" );
	var initialWeatherType = $(this).data( "weather-type" );
	var initialIsDay = $(this).data( "is-day" );
	var initialBeats = $(this).data( "beats" );
	var initialBeatsLink = $(this).data( "beats-link" );
  	var isAlreadyModified = $(this).data("saph-done");
  	if(isAlreadyModified){
  		return true;
  	}

  	var colorToUse;
  	if(isWhiteBackground){
  		colorToUse = "black";
  	}else{
  		colorToUse = "white";
  	}

  	//Create text
  	$(this).append('<span class="margin-right-15">' + text + '</span>');
  	//Create temp sign
  	//<div class="timeIcon" data-icon-color="black" data-is-day="true" data-icon-type="time"></div>
  	$(this).append('<div class="iconSaph margin-right-7 top-4 singleElement" data-icon-color="' + colorToUse + '" data-is-day="' + initialIsDay + '" data-icon-type="' + initialWeatherType + '"></div>');
  	//Create temp text
  	$(this).append('<span class="margin-right-15">' + initialTemp + '</span>');
  	//Create time sign
  	$(this).append('<div class="iconSaph margin-right-7 top-n2 vertical-aligned singleElement" data-icon-color="' + colorToUse + '" data-is-day="' + initialIsDay + '" data-icon-type="time"></div>');
  	//Create time text
  	$(this).append('<span class="margin-right-11">' + initialTime + '</span>');
  	//Create beats text
  	$(this).append('<a href="' + initialBeatsLink + '" class="disableOnMuseumVersion" target="_blank"><span class="linkTextSaph ' + colorToUse + '">' + initialBeats + '</span></a>');
  	//Add all the main div classes
  	$(this).addClass("singleElement h4-footer-texts " + colorToUse);
  	$(this).data("saph-done",true);
  	//Call function to create icons on the element
  	Drupal.behaviors.iconCreator($(this));

	});
	//Add AJAX Function to somehow update time from server
	//checkTimeAndTemperature(context);
	function checkTimeAndTemperature(context) {
		setTimeout(function() {   //calls click event after a certain time
			$.ajax({
			url: Drupal.url('admin/configuration'),
			type:"POST",
			contentType:"application/json; charset=utf-8",
			dataType:"json",
			success: function(response) {
		            //Do something to get the Time and temperature
				var newTime = "11:00pm";
				var newTemp = "50°";
				var newIsDay = true;
				var newWeatherType= "rain";
				var newBeats= "@ 500 .beats";
				var newBeatsLink = "https://www.swatch.com/de_de/internet-time/";
				$(".timeSection", context).each(function (index){
					$(this).data( "time",newTime );
					$(this).data( "temp",newTemp );
					$(this).data( "is-day",newIsDay );
					$(this).data( "weather-type",newWeatherType );
					$(this).data( "beats",newBeats );
					$(this).data( "beats-link",newBeatsLink );
					$(this).data( "saph-done","false" );
					//Eliminate all children
					$(this).empty();
				});
			}
		});
		}, 60000);
	}
  }

//Main Menu Creator
  Drupal.behaviors.mainMenu = {
		    attach: function (context) {
		    		Drupal.behaviors.mainMenuCreator(context)
		    }
  }

  Drupal.behaviors.mainMenuCreator = function (context) {
	$(".mainMenu", context).each(function (index){
		var menus = $(this).data( "menus" );
		var menuSelected = $(this).data( "menu-selected" );
	    	var isAlreadyModified = $(this).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}
	    	var mainMenu = $(this);
	    	var menuElement;
	    	if(menus){
	    		menus.forEach(function(menu) {

					//set class for hide on museum version?
					var homv = "";
					if(menu.url.indexOf("apply") >= 0 || menu.url.indexOf("user") >= 0){
						homv = " hideOnMuseumVersion";
					}

					//add menu link
	    			if(menuSelected == menu.text){
	    				menuElement = $('<a class="mainMenu-link'+homv+'" href="' + menu.url + '"><span data-text-color="black" class="black link-primary linkTextSaph">' + menu.text + '</span></a>');
	    			} else{
	    				menuElement = $('<a class="mainMenu-link'+homv+'" href="' + menu.url + '"><span data-text-color="black" class="black link-secondary linkTextSaph">' + menu.text + '</span></a>');
	    			}
			    	mainMenu.append(menuElement);

	    		});

	    	}

	    	//Add all the main div classes
	    	$(this).addClass("singleElement");
	    	$(this).data("saph-done",true);
  	});
  }

//Login Creator
  Drupal.behaviors.loginMenu = {
		    attach: function (context) {
		    		Drupal.behaviors.loginMenuCreator(context);
		    }
  }

  Drupal.behaviors.loginMenuCreator = function (context){
	$(".loginMenu", context).each(function (index){
	Drupal.behaviors.functions.consolog("login Creator");
	var hasSearch = $(this).data("has-search");
	var hasMsgs = $(this).data("has-msgs");
	var isLoggedIn = $(this).data("is-logged-in");
	var loginText = $(this).data("text");
	var loginURL = $(this).data("login-url");
	var msgsURL = $(this).data("msgs-url");
  var langSwitch = $(this).data("lang-switch");
	var activeMsgs = $(this).data("active-msgs");
  var isAlreadyModified = $(this).data("saph-done");
  if(isAlreadyModified){
  		return true;
  	}

  	//Search Icon
  	if(hasSearch){
  		$(this).append('<div class="iconSaph singleElement margin-right-11 top-4" data-icon-color="gray" data-icon-type="search"></div>');
  	}
  	//Msgs Icon
  	if(isLoggedIn && activeMsgs){
  		if(hasMsgs){
  			$(this).append('<div class="singleElement margin-right-11"><a href="' + msgsURL + '" target="_self"><div class="iconSaph singleElement top-4" data-icon-color="black" data-icon-type="msgs"></div></a></div>');
  		}
  		else {
  			$(this).append('<div class="singleElement margin-right-11"><a href="' + msgsURL + '" target="_self"><div class="iconSaph singleElement top-4" data-icon-color="black" data-icon-type="msgs_empty"></div></a></div>');
  		}
  	}
  	//Login Icon
  	$(this).append('<div class="singleElement margin-right-11"><a href="' + loginURL + '" target="_self"><div class="iconSaph singleElement  top-4" data-icon-color="black" data-icon-type="login"></div></a></div>');

  	//Text With URL Button
  	$(this).append('<a href="' + loginURL + '"><span data-text-color="black" class="black link-secondary linkTextSaph margin-right-11">' + loginText + '</span></a>');

    if(langSwitch && langSwitch !== '0' && langSwitch !== 'false') {
      // if simplified chinese show mandarin characters.
      let langSwitchLabel = langSwitch.toUpperCase() === "ZH-HANS" ? " 中文" : "EN";

      $(this).append(`\
      <div class="langSwitch text-right" id="langLeft" data-is-white-background="true">\
        <a class="black link-secondary linkTextSaph" href=/${langSwitch}>\
            <div class="iconSaph top-4" data-icon-color="black" data-icon-type="globe"></div>\
            ${langSwitchLabel}\
        </a>\
      </div>`);
    }

  	Drupal.behaviors.iconCreator($(this));
  	//Add all the main div classes
  	$(this).addClass("singleElement");
  	$(this).data("saph-done",true);

	});
  }

//Navigation Header
  Drupal.behaviors.navigationHeader = {
		    attach: function (context) {
		    		Drupal.behaviors.navigationHeaderCreator(context);
		    }
  }

  Drupal.behaviors.navigationHeaderCreator = function (context){
	var mainContent = $(".saphNavHeader", context).first();
	var menus = $(mainContent).data( "menus" );
	var menuSelected = $(mainContent).data( "menu-selected" );

	var isLoggedIn = $(mainContent).data("is-logged-in");
	var loginText = $(mainContent).data("login-text");
	var loginURL = $(mainContent).data("login-url");
	var hasMsgs = $(mainContent).data("has-msgs");
	var activeMsgs = $(mainContent).data("active-msgs");
	var msgsURL = $(mainContent).data("msgs-url");
	var cityText = $(mainContent).data( "city-text" );
	var initialTime = $(mainContent).data( "time" );
	var initialTemp = $(mainContent).data( "temp" );
	var initialWeatherType = $(mainContent).data( "weather-type" );
	var initialIsDay = $(mainContent).data( "is-day" );
	var initialBeats = $(mainContent).data( "beats" );
	var initialBeatsLink = $(mainContent).data( "beats-link" );
  var langSwitch = $(mainContent).data("lang-switch");

  	var isAlreadyModified = $(mainContent).data("saph-done");
  	if(isAlreadyModified){
  		return true;
  	}

  	if($("#toolbar-administration").length){
  		//$(mainContent).css("top",80);
  		$(mainContent).css("top",39);
  	}

  	if($(".toolbar-tray-open").length ){
  		$(mainContent).css("margin-left",240);
  	}else{
  		$(mainContent).css("margin-left",0);
  	}


  	var fullContentsHTML = '';
  	fullContentsHTML += ('<div class="saphNavHeader-mainContainer container-fluid main-content-offset center">');
  	fullContentsHTML += ('<div class="timeSection text-left" data-is-white-background="true" data-text="' + cityText + '" data-time="' + initialTime + '" data-temp="' + initialTemp +
  			'"data-weather-type="' + initialWeatherType + '" data-is-day="' + initialIsDay + '" data-beats="' + initialBeats + '" data-beats-link="' + initialBeatsLink + '"></div>');
  	fullContentsHTML += ('<div class="logoImage text-left" id="logoImageLeft" data-is-white-background="true"></div>');

  	fullContentsHTML += ('<div class="loginMenu hideOnMuseumVersion text-right"  data-has-search="false" data-has-msgs="' + hasMsgs + '" data-active-msgs="' + activeMsgs + '" data-is-logged-in="' + isLoggedIn + '" data-text="' + loginText + '" data-login-url="' + loginURL + '" data-msgs-url="' + msgsURL + '" data-lang-switch="' + langSwitch + '"></div>');

  	fullContentsHTML += ('<div class="saphNavHeader-button" data-expanded="false"><div class="position-relative">')
  	//Msgs Icon
  	if(isLoggedIn && activeMsgs){
  		if(hasMsgs){
  			fullContentsHTML += ('<div class="iconSaph singleElement" data-icon-color="black" data-icon-type="round_indicator"></div>');
  		}
  	}
  	fullContentsHTML += ('<hr class="saphNavHeader-button-line1">')
  	fullContentsHTML += ('<hr class="saphNavHeader-button-line2">')
  	fullContentsHTML += ('<hr class="saphNavHeader-button-line3">')
  	fullContentsHTML += ('</div></div>');
  	fullContentsHTML += ('<div class="centerSection" id="centerSection">');
  	fullContentsHTML += ('<div class="logoImage text-center" id="logoImageCenter" data-is-white-background="true"></div>');
  	fullContentsHTML += ('<div class="mainMenu text-center" data-menus=\'' + JSON.stringify(menus) + '\' data-menu-selected="' + menuSelected + '"></div>');
  	fullContentsHTML += ('</div>');
  	fullContentsHTML += ('<div class="saphNavHeader-collapseCenter">');
  	fullContentsHTML += ('</div>');
  	fullContentsHTML += ('</div>');//Container fluid
  	$(mainContent).append(fullContentsHTML);
  	Drupal.behaviors.iconCreator($(mainContent));
  	Drupal.behaviors.logoImageCreator($(mainContent));
  	Drupal.behaviors.timeAndTemperatureBlockCreator($(mainContent));
  	Drupal.behaviors.mainMenuCreator($(mainContent));
  	Drupal.behaviors.loginMenuCreator($(mainContent));
  	$(mainContent).addClass("navbar-fixed-top blurred-background");
  	$(mainContent).data("saph-done",true);
  }

  //Scroll for navigation header
  Drupal.behaviors.navHeaderScroll = {
		    attach: function (context) {
		    		Drupal.behaviors.navHeaderScrollFunction(context);
		    }
  }

  Drupal.behaviors.navHeaderScrollFunction = function (context){
  	$(window).scroll(function() {
		if(Drupal.behaviors.globalVariables.currentMediaType == "Desktop" || Drupal.behaviors.globalVariables.currentMediaType == "Tablet"){
			Drupal.behaviors.changeHeaderToModeWithScroll();
		}
	});
  }


  Drupal.behaviors.navToggleClicked = {
		    attach: function (context) {
		    		Drupal.behaviors.navToggleClickedFunction(context);
		    }
  }

  Drupal.behaviors.navToggleClickedFunction = function (context){
  	$( ".saphNavHeader-button",context ).click(function() {
		  var isExpanded = $(this).hasClass("saphNavHeader-button-expanded");
		  if(!isExpanded){
  		  $('.saphNavHeader').addClass("saphNavHeader-fullHeight");
  		  $(".saphNavHeader").removeClass('saphNavHeader-singleLineHeight');
  		  $( ".saphNavHeader-button" ).addClass("saphNavHeader-button-expanded");
  		  $(".saphNavHeader .timeSection").removeClass("dissappearElement");
  		  $(".saphNavHeader .saphNavHeader-collapseCenter").removeClass("dissappearElement height-0");
		  }else{
  		  $('.saphNavHeader').removeClass("saphNavHeader-fullHeight");
  		  $(".saphNavHeader").addClass('saphNavHeader-singleLineHeight');
  		  $( ".saphNavHeader-button" ).removeClass("saphNavHeader-button-expanded");
  		  $(".saphNavHeader .timeSection").addClass("dissappearElement");
  		  $(".saphNavHeader .saphNavHeader-collapseCenter").addClass("dissappearElement height-0");
		  }
		});
  }



  Drupal.behaviors.changeHeaderToHandheldMode = function () {
	  Drupal.behaviors.resetNavigationHeaderElements();
	  $('.tablet-main-menu').addClass('hideElement');
	  $(".saphNavHeader #logoImageLeft").addClass("singleElement logoImage-singleLine");
	  $(".saphNavHeader #logoImageCenter").addClass("hideElement");
	  $( ".saphNavHeader-button" ).removeClass("hideElement");
	  //Add elements to collapsable menu
	  //main menu
	  $(".saphNavHeader .mainMenu").appendTo('.saphNavHeader .saphNavHeader-collapseCenter');
	  //login
	  $(".saphNavHeader .loginMenu").appendTo('.saphNavHeader .saphNavHeader-collapseCenter');
	  //temp
	  $(".saphNavHeader .saphNavHeader-collapseCenter").after($(".saphNavHeader .timeSection"));
	  $(".saphNavHeader .saphNavHeader-collapseCenter").addClass("elementAnimation dissappearElement height-0");
	  $(".saphNavHeader .timeSection").addClass("dissappearElement");
	  //$("body").addClass("body-small-nav-padding");
	  $(".saphNavHeader").addClass('saphNavHeader-singleLineHeight elementAnimation');
  }

  Drupal.behaviors.changeHeaderToModeWithScroll = function (event) {
	  	var positionOfScroll = $(window).scrollTop();
		if(positionOfScroll > 5 && $(".saphNavHeader").hasClass("saphNavHeader-singleLineHeight")){
			return true;
		} else if(positionOfScroll <= 5 && $(".saphNavHeader").hasClass("saphNavHeader-doubleLineHeight")){
			return true;
		}
		if(Drupal.behaviors.globalVariables.currentMediaType == "Desktop"){
			Drupal.behaviors.changeHeaderToDesktopMode(true);
		}
		else{
			Drupal.behaviors.changeHeaderToTabletMode(true);
		}
}

  Drupal.behaviors.changeHeaderToTabletMode = function (isAnimated) {
	  var positionOfScroll = $(window).scrollTop();
	  if(!isAnimated){
		  Drupal.behaviors.resetNavigationHeaderElements();
		  $('.tablet-main-menu').removeClass('hideElement');
		  //$('.navbar-collapse').collapse('hide');
		  $( ".saphNavHeader-button" ).addClass("hideElement");
		  //$('.saphNavHeader .tablet-main-menu').append($(".saphNavHeader .mainMenu"));
		  $(".saphNavHeader #logoImageLeft").after($(".saphNavHeader #centerSection"));
			//$(".saphNavHeader #centerSection").append($(".saphNavHeader #logoImageCenter"));
		  $(".saphNavHeader #logoImageCenter").after($(".saphNavHeader .mainMenu"));
		  $(".saphNavHeader .mainMenu").after($(".saphNavHeader .loginMenu"));
		  $(".saphNavHeader .mainMenu").addClass("singleElement mainMenu-doubleLine");
		  //$('.saphNavHeader .tablet-main-menu').append($(".saphNavHeader .loginMenu"));
		  $(".saphNavHeader .loginMenu").addClass("singleElement");
		  $(".saphNavHeader .timeSection").addClass("hideElement");
		  $(".saphNavHeader #logoImageLeft").addClass("hideElement");
		  $(".saphNavHeader .saphNavHeader-collapseCenter").addClass("hideElement");
	  }
	  var transitionEvent = Drupal.behaviors.whichTransitionEvent();

	  if(positionOfScroll > 5){
		  if(!isAnimated){
			  //$('.saphNavHeader .tablet-main-menu').addClass("mainMenu-singleLine");
			  $(".saphNavHeader #logoImageCenter").addClass("dissappearElement");
			  $(".saphNavHeader #centerSection").addClass("centerSection-animationStep1");
			  $(".saphNavHeader").addClass("saphNavHeader-singleLineHeight");
			  //$("body").addClass("body-small-nav-padding");
		  }else{
				//Add Animated Classes to elements and first steps
				$(".saphNavHeader #centerSection").addClass("elementAnimation centerSection-animationStep1");
				$(".saphNavHeader #logoImageCenter").addClass ("dissappearElement elementAnimation");
				//$(".saphNavHeader .tablet-main-menu").addClass("elementAnimation mainMenu-singleLine");
				//$(".saphNavHeader .tablet-main-menu").removeClass("mainMenu-doubleLine");
				$(".saphNavHeader").addClass("elementAnimation saphNavHeader-singleLineHeight");
				$(".saphNavHeader").removeClass("saphNavHeader-doubleLineHeight");
				//$("body").addClass("elementAnimation body-small-nav-padding");
				//$("body").removeClass("body-big-nav-padding");
				//First Step
				$(".saphNavHeader #logoImageCenter").one(transitionEvent,
					    function(e) {
							$(".saphNavHeader #centerSection").removeClass ("elementAnimation");
							$(".saphNavHeader #logoImageCenter").removeClass ("elementAnimation");
							//$(".saphNavHeader .tablet-main-menu").removeClass ("elementAnimation");
							$(".saphNavHeader").removeClass("elementAnimation");
							//$("body").removeClass("elementAnimation");
							Drupal.behaviors.functions.consolog("Type B First step");
					    });
		  }
	  } else{
		  if(!isAnimated){
			  //$('.saphNavHeader .tablet-main-menu').addClass("mainMenu-doubleLine");
			  //$(".saphNavHeader #logoImageCenter").addClass("logoImage-doubleLine");
			  //$(".saphNavHeader #centerSection").addClass("logoImage-doubleLine");
			  $(".saphNavHeader").addClass("saphNavHeader-doubleLineHeight");
			  //$("body").addClass("body-big-nav-padding");
		  }else{
				$(".saphNavHeader #centerSection").addClass("elementAnimation");
				$(".saphNavHeader #centerSection").removeClass("centerSection-animationStep1");
				$(".saphNavHeader #logoImageCenter").addClass("elementAnimation");
				$(".saphNavHeader #logoImageCenter").removeClass("dissappearElement");
				//$('.saphNavHeader .tablet-main-menu').addClass("elementAnimation mainMenu-doubleLine");
				//$(".saphNavHeader .tablet-main-menu").removeClass("mainMenu-singleLine");
				$(".saphNavHeader").addClass("elementAnimation saphNavHeader-doubleLineHeight");
				$(".saphNavHeader").removeClass("saphNavHeader-singleLineHeight");
				//$("body").addClass("elementAnimation body-big-nav-padding");
				//$("body").removeClass("elementAnimation body-small-nav-padding");
				//First Step
				$(".saphNavHeader #centerSection").one(transitionEvent,
					    function(e) {
							$(".saphNavHeader #logoImageCenter").removeClass("elementAnimation");
							$(".saphNavHeader #centerSection").removeClass("elementAnimation");
							//$(".saphNavHeader .tablet-main-menu").removeClass("elementAnimation");
							$(".saphNavHeader").removeClass("elementAnimation");
							//$("body").removeClass("elementAnimation");
							Drupal.behaviors.functions.consolog("Type A First step");
					    });
		  }
	  }
  };

  Drupal.behaviors.changeHeaderToDesktopMode = function (isAnimated) {
	  	var positionOfScroll = $(window).scrollTop();
		if(!isAnimated){
			Drupal.behaviors.resetNavigationHeaderElements();
			$('.tablet-main-menu').addClass('hideElement');
			//$('.navbar-collapse').collapse('hide');
			$( ".saphNavHeader-button" ).addClass("hideElement");
			$(".saphNavHeader .saphNavHeader-collapseCenter").addClass("hideElement");
		}else
		{
			$(".saphNavHeader .timeSection").finish();
			//$(".saphNavHeader #logoImageCenter").finish();
			$(".saphNavHeader #logoImageLeft").finish();
			$(".saphNavHeader #centerSection").finish();
			$(".saphNavHeader .mainMenu").finish();
			$(".saphNavHeader").finish();
			//$("body").finish();
		}
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();

		if(positionOfScroll > 5){
			if(!isAnimated)
			{
				$(".saphNavHeader .saphNavHeader-mainContainer").prepend($(".saphNavHeader .timeSection"));
				$(".saphNavHeader .timeSection").addClass("singleElement text-left dissappearElement");
				$(".saphNavHeader .timeSection").after($(".saphNavHeader .loginMenu"));
				$(".saphNavHeader .loginMenu").addClass("singleElement text-right");
				//Positionate logoImage and mainMenu
				$(".saphNavHeader .loginMenu").after($(".saphNavHeader #logoImageLeft"));
				//$(".saphNavHeader #logoImageLeft").after($(".saphNavHeader #logoImageCenter"));
				$(".saphNavHeader #logoImageLeft").after($(".saphNavHeader #centerSection"));
				$(".saphNavHeader #centerSection").append($(".saphNavHeader #logoImageCenter"));
				$(".saphNavHeader #logoImageCenter").after($(".saphNavHeader .mainMenu"));

				$(".saphNavHeader #centerSection").addClass("centerSection-animationStep1");
				$(".saphNavHeader #logoImageCenter").addClass("dissappearElement");
				//$(".saphNavHeader #logoImageLeft").addClass("logoImage-singleLine");
				$(".saphNavHeader .mainMenu").addClass("singleElement mainMenu-doubleLine"); //Still on the double line to stay in center
				$(".saphNavHeader").addClass("saphNavHeader-singleLineHeight");
				//$("body").addClass("body-small-nav-padding");
			} else {
				//Add Animated Classes to elements and first steps
				$(".saphNavHeader .timeSection").addClass ("elementAnimation dissappearElement");
				$(".saphNavHeader #logoImageCenter").addClass("elementAnimation dissappearElement");
				$(".saphNavHeader #centerSection").addClass("elementAnimation centerSection-animationStep1");
				//$(".saphNavHeader #logoImageCenter").removeClass("logoImage-doubleLine");
				$(".saphNavHeader #logoImageLeft").addClass("elementAnimation");
				$(".saphNavHeader #logoImageLeft").removeClass("dissappearElement");
				//$(".saphNavHeader .mainMenu").addClass("elementAnimation mainMenu-singleLine");
				//$(".saphNavHeader .mainMenu").removeClass("mainMenu-doubleLine");
				$(".saphNavHeader").addClass("elementAnimation saphNavHeader-singleLineHeight");
				$(".saphNavHeader").removeClass("saphNavHeader-doubleLineHeight");
				//$("body").addClass("elementAnimation body-small-nav-padding");
				//$("body").removeClass("body-big-nav-padding");
				//First Step
				$(".saphNavHeader #centerSection").one(transitionEvent,
					    function(e) {
							$(".saphNavHeader #logoImageCenter").removeClass("elementAnimation");
							$(".saphNavHeader #centerSection").removeClass ("elementAnimation");
							$(".saphNavHeader #logoImageLeft").removeClass("elementAnimation");
							$(".saphNavHeader .timeSection").removeClass ("elementAnimation");
							$(".saphNavHeader").removeClass("elementAnimation");
							//$("body").removeClass("elementAnimation");
							Drupal.behaviors.functions.consolog("Type B First step");
					    });
			}
		} else if(positionOfScroll <= 5) {
			if(!isAnimated){
				$(".saphNavHeader .saphNavHeader-mainContainer").prepend($(".saphNavHeader .timeSection"));
				$(".saphNavHeader .timeSection").addClass("singleElement text-left");
				$(".saphNavHeader .timeSection").after($(".saphNavHeader .loginMenu"));
				$(".saphNavHeader .loginMenu").addClass("singleElement text-right");
				//Positionate logoImage and mainMenu
				$(".saphNavHeader .loginMenu").after($(".saphNavHeader #logoImageLeft"));
				//$(".saphNavHeader #logoImageLeft").after($(".saphNavHeader #logoImageCenter"));
				$(".saphNavHeader #logoImageLeft").after($(".saphNavHeader #centerSection"));
				$(".saphNavHeader #centerSection").append($(".saphNavHeader #logoImageCenter"));
				$(".saphNavHeader #logoImageCenter").after($(".saphNavHeader .mainMenu"));

				$(".saphNavHeader #logoImageCenter").addClass("logoImage-doubleLine");
				$(".saphNavHeader #logoImageLeft").addClass("dissappearElement");
				$(".saphNavHeader .mainMenu").addClass("singleElement mainMenu-doubleLine");
				$(".saphNavHeader").addClass("saphNavHeader-doubleLineHeight");
				//$("body").addClass("body-big-nav-padding");

			} else {
				$(".saphNavHeader .timeSection").addClass ("elementAnimation");
				$(".saphNavHeader .timeSection").removeClass ("dissappearElement");
				$(".saphNavHeader #logoImageCenter").addClass("elementAnimation");
				$(".saphNavHeader #logoImageCenter").removeClass("dissappearElement");
				$(".saphNavHeader #centerSection").addClass("elementAnimation");
				$(".saphNavHeader #centerSection").removeClass("centerSection-animationStep1");

				$(".saphNavHeader #logoImageLeft").addClass("elementAnimation dissappearElement");
				//$(".saphNavHeader #logoImageLeft").removeClass("logoImage-singleLine");

				//$(".saphNavHeader .mainMenu").addClass("elementAnimation mainMenu-doubleLine");
				//$(".saphNavHeader .mainMenu").removeClass("mainMenu-singleLine");
				$(".saphNavHeader").addClass("elementAnimation saphNavHeader-doubleLineHeight");
				$(".saphNavHeader").removeClass("saphNavHeader-singleLineHeight");
				//$("body").addClass("elementAnimation body-big-nav-padding");
				//$("body").removeClass("body-small-nav-padding");
				//First Step
				$(".saphNavHeader #logoImageCenter").one(transitionEvent,
					    function(e) {
							$(".saphNavHeader #logoImageCenter").removeClass("elementAnimation");
							$(".saphNavHeader #centerSection").removeClass("elementAnimation");
							$(".saphNavHeader #logoImageLeft").removeClass("elementAnimation");
							$(".saphNavHeader .timeSection").removeClass ("elementAnimation");
							$(".saphNavHeader").removeClass("elementAnimation");
							//$("body").removeClass("elementAnimation");

							Drupal.behaviors.functions.consolog("Type A First step");
					    });
			}
		}

	};

  Drupal.behaviors.resetNavigationHeaderElements = function () {
		$(".saphNavHeader .timeSection").removeClass("hideElement singleElement sinlg dissappearElement appearElement-animated text-left text-center");
		$(".saphNavHeader #logoImageCenter").removeClass("hideElement singleElement logoImage-animationStep1 dissappearElement text-left text-center logoImage-doubleLine logoImage-singleLine");
		$(".saphNavHeader #centerSection").removeClass("centerSection-animationStep1");
		$(".saphNavHeader #logoImageLeft").removeClass("hideElement singleElement logoImage-animationStep1 dissappearElement text-left text-center logoImage-doubleLine logoImage-singleLine");
		$(".saphNavHeader .loginMenu").removeClass("hideElement singleElement text-center text-right float-right");
		$(".saphNavHeader .mainMenu").removeClass("hideElement singleElement mainMenu-doubleLine mainMenu-singleLine");
		$('.saphNavHeader .tablet-main-menu').removeClass("mainMenu-doubleLine mainMenu-singleLine");
		//$("body").removeClass("body-small-nav-padding body-big-nav-padding");
		$('.saphNavHeader').removeClass("saphNavHeader-fullHeight saphNavHeader-doubleLineHeight saphNavHeader-singleLineHeight");
		$(".saphNavHeader-button").removeClass("saphNavHeader-button-expanded");
		$(".saphNavHeader .saphNavHeader-collapseCenter").removeClass("hideElement");
	};

  Drupal.behaviors.maxHeightOfNavBar = function () {
  	if(Drupal.behaviors.globalVariables.currentMediaType == "Handheld"){
  		return 64;
  	}else if(Drupal.behaviors.globalVariables.currentMediaType == "Tablet"){
  		return 120;
  	}else{
  		return 120;
  	}
  }
  Drupal.behaviors.minHeightOfNavBar = function () {
  	if(Drupal.behaviors.globalVariables.currentMediaType == "Handheld"){
  		return 64;
  	}else if(Drupal.behaviors.globalVariables.currentMediaType == "Tablet"){
  		return 58;
  	}else{
  		return 72;
  	}
  }

  Drupal.behaviors.actualHeightOfNavBar = function () {
	  return $(".saphNavHeader").height();
  }


})(jQuery);
